const themeColor = JSON.parse(localStorage.getItem('themeColor'))
// console.log("color value: ", color);
// export const ThemeColor = color != null ? color.website_color : "#000dff"
// export const ThemeColor = color.website_color
export const ThemeColor = themeColor
// export const ThemeColor = "#E70074"
